module.exports = __webpack_public_path__ + "d8702867b5d3130adaa71ad3cc36fbdb.png";